/**
 * Before/After block.
 * 
 */

/**
 * Desktop: Before/after image comparison viewers.
 * Mobile: Viewers appear in horizontal slider.
 */

const $ = jQuery;   // jQuery loaded via WordPress enqueue process

let sliderDebounce;

function initModule() {
    const mediaQuery = window.matchMedia(`(min-width: 1024px)`);
    setupUI(mediaQuery); // Call handler at run time
    mediaQuery.addListener(setupUI); // Attach listener
}

function setupUI(mq) {
    
    if (sliderDebounce) {
        clearTimeout(sliderDebounce);
    } 
    // Set this debouncer on a longer schedule than
    // our Juxt debouncer, so the Juxts have a chance
    // to resize before we init the slider.
    sliderDebounce = setTimeout(() => {
        sliderDebounce = null;
        if (!mq.matches) {
            // We're on mobile -- init the slider
            initBAViewersSlider();
        } else {
            // We're on desktop -- let's run a size reset
            // on our juxts
            resetJuxt();
        }
    }, 600);
}

function initBAViewersSlider() {
    // Set up slider for before/after viewers in mobile.
    const $mySlider = $('.before-after__viewers');
    const options = {
        // centerMode:true,
        // centerPadding:'105px',
        cssEase:'ease-out',
        infinite:true,
        mobileFirst:true,
        slidesToShow:1,
        swipe:false,
        swipeToSlide:false,
        slidesToScroll:1,
        arrows:true,
        adaptiveHeight:true,
        prevArrow: $('.prev'),
        nextArrow: $('.next'),
        responsive: [
            {
                breakpoint:1023,
                settings: "unslick"
            }
        ]
    };
    
    $mySlider.slick(options);
}

function initJuxtapose() {
    let debouncer = null;

    window.addEventListener('resize', () => {
        if (debouncer) {
            clearTimeout(debouncer);
        } 
        debouncer = setTimeout(() => {
            debouncer = null;
            resetJuxt();
        }, 100);
    });
   
}

function resetJuxt() {
    const sliders = window.juxtapose.sliders;
    let 
        newW = 0,
        clonedSliders = $('.slick-cloned .juxtapose');

    sliders.forEach((slider) => {
        slider.wrapper.setAttribute('style', '');
        slider.setWrapperDimensions();
        newW = slider.wrapper.offsetWidth;
    })

    clonedSliders.attr('style', '');
    clonedSliders.width(newW);
    clonedSliders.height(newW);
}

exports.init = function () {
    // Run init methods...
    initModule();
    initJuxtapose();

    //initBAViewers();
};